import React, { useState, useEffect } from 'react';
import { Button } from 'components/buttons'
import { MenuItem } from '@blueprintjs/core';
import PropTypes from 'prop-types';

export function InstantEventButton({
    id = null,
    text = "Create Event",
    icon = "download",
    intent = "primary",
    eventTypeId = null,
    buttonDisabled = true,
    buttonType = "Button",
    onEventCreate = () => {}
}) {

    const [creatingEvent, setCreatingEvent] = useState(false);

    useEffect(function (){
        setCreatingEvent(buttonDisabled);
    }, [buttonDisabled])

    return buttonType === "MenuItem" ?
    (
        <MenuItem 
            icon={icon} 
            intent={intent} 
            onClick={() => onEventCreate(eventTypeId)} 
            id={id} 
            disabled={creatingEvent} 
            text={text} 
        />
    ) : (
        <Button 
            icon={icon} 
            intent={intent} 
            onClick={() => onEventCreate(eventTypeId)} 
            id={id} 
            disabled={creatingEvent} 
            text={text} 
        />
    );
}

InstantEventButton.propTypes = {
    id: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    intent: PropTypes.string,
    eventTypeId: PropTypes.number,
    buttonDisabled: PropTypes.bool,
    buttonType: PropTypes.string,
    onEventCreate: PropTypes.func.isRequired
};